import axios from 'axios';
import { User, NetflixAccount, LoginResponse } from '../types';

const API_URL = 'https://srv-6q4s1d65sq4dxx.myflixcode.com/api';

const api = axios.create({
    baseURL: API_URL,
});

// Add token to requests if available
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const authApi = {
    adminLogin: async (username: string, password: string): Promise<LoginResponse> => {
        const response = await api.post('/auth/j8n5x2v4l9q7/login', { username, password });
        return response.data;
    },

    userLogin: async (username: string, password: string): Promise<LoginResponse> => {
        const response = await api.post('/auth/user/login', { username, password });
        return response.data;
    },
};

export const userApi = {
    getAll: async (): Promise<User[]> => {
        const response = await api.get('/users');
        return response.data;
    },

    create: async (userData: { username: string; password: string; role: string }): Promise<User> => {
        const response = await api.post('/users', userData);
        return response.data;
    },

    delete: async (id: number): Promise<void> => {
        await api.delete(`/users/${id}`);
    },
};

export const netflixAccountApi = {
    getAll: async (): Promise<NetflixAccount[]> => {
        const response = await api.get('/netflix-accounts');
        return response.data;
    },

    getUserAccounts: async (userId: number): Promise<NetflixAccount[]> => {
        const response = await api.get(`/netflix-accounts/user/${userId}`);
        return response.data;
    },

    create: async (accountData: { email: string; password: string; userId?: number }): Promise<NetflixAccount> => {
        const response = await api.post('/netflix-accounts', accountData);
        return response.data;
    },

    update: async (id: number, userId: number | null): Promise<void> => {
        await api.put(`/netflix-accounts/${id}`, { userId });
    },

    delete: async (id: number): Promise<void> => {
        await api.delete(`/netflix-accounts/${id}`);
    },

    testLogin: async (credentials: { email: string; password: string }): Promise<{ success: boolean; message?: string }> => {
        try {
            const response = await api.post('/netflix-accounts/test-login', credentials);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    checkAccount: async (email: string): Promise<{ exists: boolean }> => {
        const response = await api.post('/netflix-accounts/check', { email });
        return response.data;
    },

    checkTravelCode: async (email: string): Promise<{ found: boolean; link?: string }> => {
        const response = await api.post('/netflix-accounts/check-travel-code', { email });
        return response.data;
    },

    checkHousehold: async (email: string): Promise<{ found: boolean; link?: string }> => {
        const response = await api.post('/netflix-accounts/check-household', { email });
        return response.data;
    },

    checkResetPassword: async (email: string): Promise<{ found: boolean; link?: string }> => {
        const response = await api.post('/netflix-accounts/check-reset-password', { email });
        return response.data;
    },

    decryptPassword: async (encryptedPassword: string) => {
        const response = await api.post('/netflix-accounts/decrypt-password', {
            encryptedPassword
        });
        return response.data;
    },
}; 